import { get_utc_offset } from '@/Components/MotionActivity/MotionActivityUtils';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { DefaultTimezone } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useApiQuery } from './useApiQuery';

const NumberOfDays = 7;

const useGetUserMotionEventsByTimeRange = ({
  useruuid,
  timezone,
  fetchDays = NumberOfDays,
  enabled = true,
}) => {
  const trans = useSelector(translator);
  const userEventsApi = useSelector((state) => state.apis.userEventsApi);

  const tz = timezone || DefaultTimezone;
  const timezoneOffset = get_utc_offset(tz, DefaultTimezone);
  const applyTimezoneOffset = (date) => date.replace(/Z|(\+|-)\d\d:\d\d$/, timezoneOffset);

  const activityDateStart = applyTimezoneOffset(
    moment()
      .tz(tz)
      .subtract(fetchDays - 1, 'days')
      .startOf('day')
      .format()
  );
  const activityDateEnd = applyTimezoneOffset(moment().tz(tz).endOf('day').format());

  return useApiQuery(
    ['userMotionEventsByTimeRange', useruuid, activityDateStart, activityDateEnd],
    () =>
      new Promise((resolve, reject) => {
        userEventsApi.userMotionEventsByTimeRange(
          useruuid,
          activityDateStart,
          activityDateEnd,
          {},
          apiCallback({
            translator: trans,
            successCallback: (data) => {
              resolve(data['user_events'] || []);
            },
            errorCallback: (err) => {
              console.error('Error fetching motion data:', err);
              reject(err);
            },
            failCallback: (err) => {
              console.error('Failed to fetch motion data:', err);
              reject(err);
            },
          })
        );
      }),
    { enabled: !!useruuid && enabled }
  );
};

export default useGetUserMotionEventsByTimeRange;
